import uni from './openUniPay'
import one from './openOnePay'

export default {
  uni: uni,
  one: one
}
